<template>
  <el-dialog
    width="1260px"
    :center="true"
    :show-close="true"
    :visible.sync="visiable"
    top="5vh"
    title="注销记录"
  >
    <el-form
      :model="param"
      :inline="true"
      label-width="150px"
      class="formInline"
      size="mini"
    >
      <div class="slide-wrap" style="height: auto">
        <el-form-item label="促销员姓名：">
          <el-input
            placeholder="请输入促销员姓名..."
            :maxlength="30"
            v-model="param.name"
          />
        </el-form-item>
        <el-form-item label="促销员身份证号码：">
          <el-input
            placeholder="请输入促销员身份证号码..."
            :maxlength="30"
            v-model="param.idcard"
          />
        </el-form-item>
        <el-form-item label="状态：">
          <el-select
            filterable
            placeholder="请选择..."
            v-model="param.status"
            clearable
          >
            <el-option label="注销中" :value="0" />
            <el-option label="撤回注销" :value="1" />
            <el-option label="已注销" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="促销员ID：">
          <el-input
            placeholder="请输入促销员ID..."
            :maxlength="30"
            v-model="param.empPk"
          />
        </el-form-item>
        <el-form-item label="促销员手机号：">
          <el-input
            placeholder="请输入促销员手机号..."
            :maxlength="30"
            v-model="param.tel"
          />
        </el-form-item>
        <el-form-item style="float: right; margin-right: 50px">
          <el-button class="search-btn" @click="submitForm()">筛选</el-button>
          <el-button
            class="search-btn"
            @click="exportData()"
            style="margin-left: 20px"
            :loading="btnLoading"
            >导出</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <div class="tableBody">
      <el-table
        v-loading="listLoading"
        class="limitManagerTable table-expand"
        style="width: 100%"
        :data="tableData"
        size="mini"
        border
        header-row-class-name="table-header"
      >
        <el-table-column
          width="50"
          type="index"
          label="编号"
          align="center"
        ></el-table-column>
        <el-table-column
          minWidth="100"
          prop="name"
          label="促销员姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="empPk"
          minWidth="100"
          label="促销员ID"
          align="center"
        ></el-table-column>
        <el-table-column
          width="120"
          prop="tel"
          label="手机号"
          align="center"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="idcard"
          label="身份证号"
          align="center"
        ></el-table-column>
        <el-table-column
          width="140"
          prop="applyTime"
          label="申请注销时间"
          align="center"
        ></el-table-column>
        <el-table-column
          width="100"
          label="状态"
          align="center"
          prop="statusName"
        >
          <!-- <template slot-scope="scope">
            <div v-if="scope.row[6] == 1" style="color: #66cc33">关联中</div>
            <div v-if="scope.row[6] == 2">取消关联</div>
          </template> -->
        </el-table-column>
        <el-table-column
          width="140"
          prop="revokeApplyTime"
          label="撤回注销申请时间"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ computedTime(scope.row.revokeApplyTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="140"
          prop="cancelApplyTime"
          label="注销时间"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ computedTime(scope.row.cancelApplyTime) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination table-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.pageNo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="formData.pageSize"
        layout="slot,sizes, total,  prev, pager, next, jumper"
        :total="formData.total"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>
<script>
import utils from "@/common/js/util.js";
import moment from "moment";

export default {
  data() {
    return {
      allCustomers: [], //项目列表数组
      //筛选项参数
      param: {},
      param2: {},
      //表单翻页
      formData: {
        pageNo: 1,
        pageSize: 10,
        total: null,
      },
      tableData: [], //表单信息
      listLoading: false,
      visiable: false,
      btnLoading: false,
    };
  },
  methods: {
    show() {
      this.param = {};
      this.param2 = {};
      this.formData = {
        pageNo: 1,
        pageSize: 10,
        total: null,
      };
      this.visiable = true;
      this.getData();
    },
    //工具类，错误提示框
    myNotify(_this, type, normal, or) {
      utils.myNotify(_this, type, normal, or);
    },
    computedTime(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    //提交表单（筛选功能）
    submitForm() {
      this.param2 = JSON.parse(JSON.stringify(this.param));
      this.formData.pageNo = 1;
      this.getData();
    },
    //翻页
    handleSizeChange(value) {
      this.formData.pageSize = value;
      this.getData();
    },
    handleCurrentChange(value) {
      this.formData.pageNo = value;
      this.getData();
    },
    //获取数据
    getData() {
      this.listLoading = true;
      let params = {
        ...this.param2,
        pageSize: this.formData.pageSize,
        pageNo: this.formData.pageNo,
      };
      //获取表单数据
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/baseCenter/cancellationList",
        data: params,
      })
        .then((res) => {
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch((err) => {
          this.listLoading = false;
          this.myNotify(
            this,
            "error",
            err.response,
            "查询列表失败，请稍后重试"
          );
        });
      //获取总数量
      this.$http({
        method: "POST",
        headers: { "content-type": "application/json" },
        url: "/rest/baseCenter/cancellationListCount",
        data: params,
      })
        .then((res) => {
          this.formData.total = res.data;
        })
        .catch((err) => {
          this.listLoading = false;
          this.myNotify(
            this,
            "error",
            err.response,
            "查询数量失败，请稍后重试"
          );
        });
    },
    exportData() {
      this.btnLoading = true;
      this.$http({
        method: "post",
        url: "/rest/baseCenter/export",
        data: this.param,
      })
        .then((res) => {
          if (res.data && res.data.status == 200) {
            location.href = utils.returnUrlHead() + res.data.message;
            this.btnLoading = false;
          } else {
            this.btnLoading = false;
            this.$alert(res.data.message);
          }
        })
        .catch((err) => {
          this.btnLoading = false;
          this.$alert("获取注销记录失败！");
        });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tableBody {
  min-height: 634px;
}
/deep/ .el-dialog__header {
  border-bottom: 1px solid #e2e2e2 !important;
  padding: 0;
  height: 50px;
  line-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/personnelCenter/baseCenter/LogOut.vue